import { AppDispatch } from "../redux/store";
import { UserType } from "../services/user.service";
import { getNotificationStatus } from "../redux/slices/NotificationAlertSlice";

export const handleNotificationStatus = async (dispatch: AppDispatch, userType: string) => {
  const validUserTypes = [UserType.Patient, UserType.OfficeAdmin, UserType.Accounting, UserType.User];
  const audience = userType === UserType.Patient ? "PATIENT" : "OFFICE";
  if (validUserTypes.includes(userType as UserType)) {
    const result = await dispatch(getNotificationStatus({ audience }));
    return result.payload;
  }
};
